<template>
    <div>
        <h5>All Available Companies</h5>
        <div class="card">
            <div class="flex justify-content-end flex-wrap mb-3">
                <div class="flex">
                    <Button label="Create New Company" icon="pi pi-plus" @click="addCompany" />
                </div>
            </div>

            <DataTable
                v-model:first="offset"
                :rows="numberOfRows"
                :paginator="true"
                :lazy="true"
                selectionMode="single"
                @page="onPage"
                :totalRecords="totalEntities"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"


                :value="companyList"
                :resizableColumns="true"
                ref="dt"
                dataKey="id"
                :rowHover="true"
                :loading="loading"
                responsiveLayout="scroll"
            >
                <template #empty> No Companies available. </template>
                <template #loading> Loading Companies. Please wait. </template>
                <Column field="id" header="Id" style="width: 4rem" />
                <Column field="name" header="Name" />
                <Column field="type" header="Type">
                    <template #body="slotProps">
                        <span v-if="slotProps.data.type === 1">
                            FIRE AND RESCUE
                        </span>
                        <span v-else-if="slotProps.data.type === 2">
                            POLICE
                        </span>
                        <span v-else-if="slotProps.data.type === 3">
                            NHS
                        </span>
                        <span v-else-if="slotProps.data.type === 4">
                            RESIDENTIAL HEALTHCARE
                        </span>
                        <span v-else-if="slotProps.data.type === 5">
                            COMMERCIAL
                        </span>
                    </template>
                </Column>
                <Column field="actions" header="ACTIONS" style="width: 4rem">
                    <template #body="slotProps">
                        <Button
                            icon="pi pi-pencil"
                            class="p-button-rounded p-button-success mr-2"
                            @click="editCompany(slotProps.data.id)"
                            v-tooltip="'Edit Company'"
                        />
                        <Button
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-danger mr-2"
                            @click="confirmDelete(slotProps.data)"
                            v-tooltip="'Delete Company'"
                        />
                        <Button icon="pi pi-image" class="p-button-rounded p-button-info"
                            @click="manageLogo(slotProps.data.id)" v-tooltip="'Manage Logo'" />
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script setup>
import {
    buildPagination,
    getPage,
    getPerPage, setPage, setPerPage,
} from '@/composables/PaginationComposable';
import { computed, onMounted, ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import { useRouter } from 'vue-router';


const toast = useToast();
const confirm = useConfirm();
const router = useRouter();

const pageList = 'companyList'

const companyList = ref([])
const loading = ref(false)
const totalEntities = ref(0)

const offset = computed(() => {
    return getPage(pageList) * getPerPage(pageList)
})

const numberOfRows = computed(() => {
    return getPerPage(pageList)
})

const onPage = async (event) => {
    setPage(pageList, event.page)
    setPerPage(pageList, event.rows)

    loadCompanies();
};

onMounted(() => {
    buildPagination(pageList, 0, 10, [{field: "id", order: -1}])
    loadCompanies()
});

function confirmDelete(company) {
    confirm.require({
        header: 'Confirmation',
        message: 'Are you sure you want to delete the company `' + company.name + '`?',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
            deleteCompany(company.id)
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
        },
    });
}

function editCompany(companyId) {
    router.push({ path: `company/edit/${companyId}` });
}

function manageLogo(companyId) {
    router.push({
        name: 'company-logo',
        params: { id: companyId }
    });
}

function deleteCompany(companyId) {
    loading.value = true

    GlobalRequest.deleteRequest(`/v2/admin/companies/${companyId}`)
    .then(() => {
        loadCompanies()
    })
}

function loadCompanies() {

    let page_size = getPerPage(pageList)
    let page = getPage(pageList) + 1

    companyList.value = []

    loading.value = true

    GlobalRequest.getRequest('v2/admin/companies', {
        params: {
            page_size: page_size,
            page: page,
            paginate: true,
        },
    }).then((response) => {

        if (Object.hasOwn(response, 'data')) {

            if (Object.hasOwn(response.data, 'data')) {
                companyList.value = response.data.data
            }

            if (Object.hasOwn(response.data, 'total')) {
                totalEntities.value = response.data.total
            }

        }
    }).finally(() => {
        loading.value = false
    })
}

function addCompany() {
    router.push({ path: `/company/create` });
}



</script>

<style scoped lang="scss">

</style>